(() => {
  'use strict';
  const root = document.querySelector('[data-monolith-advisors]');
  if (!root || !root.querySelector('[data-advisor-care-title]')) return;
  const copy = {
  "de": {
    "ui": [
      "Hilfe mit meinem\nneuen Produkt",
      "Rahel begleitet dich beim Ausprobieren. Wähle, wozu du Tipps möchtest.",
      "Womit möchtest du starten?",
      "Lidschatten & Effekte",
      "Lippenprodukte",
      "Highlighter",
      "Pinselpflege",
      "Die Angaben auf Produkt und Verpackung gehen vor. Bei Reizungen nicht weiterverwenden.",
      "Rahel zu meinem Produkt fragen",
      "Mein Paket ist da,\naber …",
      "Emanuel hilft dir weiter. Was ist bei deiner Lieferung passiert?",
      "Ein Artikel fehlt",
      "Ein falscher Artikel kam an",
      "Ein Artikel ist beschädigt",
      "Im nächsten Schritt kannst du Bestellnummer, betroffenen Artikel und Fotos ergänzen. Bereits gesendete Bilder musst du nicht nochmals schicken.",
      "Überrasch mich,\nRahel!",
      "Wähle deine Stimmung und eine Preisgrenze. Rahel zeigt dir bis zu drei verfügbare Produkte aus ihrer kleinen Auswahl.",
      "Worauf hast du Lust?",
      "Dezent – weiche Akzente",
      "Funkelnd – Licht & Farbspiel",
      "Mutig – Farbe & Kontraste",
      "Preisgrenze pro Produkt",
      "Die Preisgrenze gilt pro Produkt; Versand kommt gegebenenfalls hinzu. Produktseite und Checkout zeigen die aktuellen Preise.",
      "Zeig mir deine Ideen",
      "Deine Auswahl: {n} passende Produkte.",
      "In Rahels Auswahl ist dafür gerade nichts verfügbar. Ändere Stil oder Preisgrenze, oder nutze den Color Finder.",
      "Bitte gib eine gültige Preisgrenze über 0 ein.",
      "Produkt ansehen",
      "Mehr Farben im Color Finder"
    ],
    "steps": [
      [
        "Starte mit wenig Produkt. Tupfe Schimmer oder Multichrome sanft auf, sofern der Markeninhaber diese Methode empfiehlt.",
        "Verblende matte Übergänge mit einem sauberen, weichen Pinsel und wenig Druck. Verwende am Auge nur dafür ausgewiesene Produkte."
      ],
      [
        "Trage zunächst eine dünne Schicht auf und arbeite von der Lippenmitte zu den Konturen.",
        "Baue die Intensität langsam auf. Verwende Gloss oder Lippenöl als Topper nur entsprechend den Herstellerhinweisen."
      ],
      [
        "Nimm wenig Produkt mit einem sauberen Pinsel auf und setze einen kleinen Akzent auf die Wangenknochen.",
        "Prüfe den Effekt bei Tageslicht und baue ihn in dünnen Schichten auf. Am Auge nur verwenden, wenn das Produkt dafür ausgewiesen ist."
      ],
      [
        "Reinige Pinsel regelmässig nach Herstellerangaben. Bei geeigneten Pinseln helfen lauwarmes Wasser und ein mildes Reinigungsmittel.",
        "Spüle Rückstände sorgfältig aus. Lass die Pinsel flach mit frei liegendem Pinselkopf trocknen; den Griff und die Zwinge nicht einweichen."
      ]
    ]
  },
  "en": {
    "ui": [
      "Help with my\nnew product",
      "Rahel helps you get started. Choose what you would like tips on.",
      "Where would you like to start?",
      "Eyeshadow & effects",
      "Lip products",
      "Highlighter",
      "Brush care",
      "Product and packaging instructions come first. Stop using a product if irritation occurs.",
      "Ask Rahel about my product",
      "My parcel arrived,\nbut …",
      "Emanuel can help. What happened with your delivery?",
      "An item is missing",
      "I received the wrong item",
      "An item is damaged",
      "Next, add your order number, affected item and photos. You do not need to send photos you have already shared again.",
      "Surprise me,\nRahel!",
      "Choose your mood and a price limit. Rahel shows up to three available products from her small selection.",
      "What are you in the mood for?",
      "Subtle – soft accents",
      "Sparkling – light & colour shifts",
      "Bold – colour & contrasts",
      "Price limit per product",
      "The limit is per product; shipping may be extra. Product pages and checkout show current prices.",
      "Show me your ideas",
      "Your selection: {n} matching products.",
      "Nothing in Rahel’s selection is available for these choices. Change your style or limit, or try the Color Finder.",
      "Please enter a valid price limit above 0.",
      "View product",
      "More colours in the Color Finder"
    ],
    "steps": [
      [
        "Start with a little product. Gently pat on shimmer or multichrome if the brand recommends that method.",
        "Blend matte edges with a clean, soft brush and light pressure. Around the eyes, use only products labelled for that area."
      ],
      [
        "Start with a thin layer and work from the centre of the lips towards the edges.",
        "Build the intensity slowly. Use gloss or lip oil as a topper only as directed by the brand."
      ],
      [
        "Pick up a little with a clean brush and add a small accent to the cheekbones.",
        "Check the effect in daylight and build in thin layers. Use around the eyes only if the product is labelled for that area."
      ],
      [
        "Clean brushes regularly following the maker’s directions. For suitable brushes, use lukewarm water and a mild cleanser.",
        "Rinse out residue carefully. Dry flat with the brush head over an edge; do not soak the handle or ferrule."
      ]
    ]
  },
  "fr": {
    "ui": [
      "De l’aide avec mon\nnouveau produit",
      "Rahel vous accompagne. Choisissez le sujet qui vous intéresse.",
      "Par quoi commencer ?",
      "Fards & effets",
      "Produits pour les lèvres",
      "Highlighter",
      "Entretien des pinceaux",
      "Les indications du produit et de son emballage sont prioritaires. Cessez l’utilisation en cas d’irritation.",
      "Interroger Rahel sur mon produit",
      "Mon colis est arrivé,\nmais…",
      "Emanuel vous aide. Que s’est-il passé avec votre livraison ?",
      "Il manque un article",
      "J’ai reçu le mauvais article",
      "Un article est abîmé",
      "Ajoutez ensuite le numéro de commande, l’article concerné et des photos. Inutile de renvoyer des photos déjà transmises.",
      "Surprends-moi,\nRahel !",
      "Choisissez votre envie et un prix maximal. Rahel propose jusqu’à trois produits disponibles dans sa petite sélection.",
      "Quelle est votre envie ?",
      "Discret – touches douces",
      "Scintillant – lumière & reflets",
      "Audacieux – couleurs & contrastes",
      "Prix maximal par produit",
      "La limite vaut par produit ; des frais de livraison peuvent s’ajouter. Les prix actuels figurent sur la fiche et au paiement.",
      "Voir tes idées",
      "Votre sélection : {n} produits correspondants.",
      "Aucun produit de la sélection de Rahel n’est disponible pour ces choix. Modifiez le style ou le budget, ou utilisez le Color Finder.",
      "Saisissez un prix maximal valide supérieur à 0.",
      "Voir le produit",
      "Plus de couleurs dans le Color Finder"
    ],
    "steps": [
      [
        "Commencez avec peu de produit. Tapotez les irisés ou multichromes si la marque recommande cette méthode.",
        "Estompez les contours mats avec un pinceau propre et doux, sans appuyer. Près des yeux, utilisez uniquement des produits prévus pour cette zone."
      ],
      [
        "Appliquez une couche fine, du centre des lèvres vers les contours.",
        "Intensifiez progressivement. Utilisez un gloss ou une huile en topper uniquement selon les indications de la marque."
      ],
      [
        "Prélevez peu de produit avec un pinceau propre et posez une petite touche sur les pommettes.",
        "Vérifiez à la lumière du jour et superposez de fines couches. Près des yeux, utilisez seulement un produit prévu pour cette zone."
      ],
      [
        "Nettoyez régulièrement selon les indications du fabricant. Pour les pinceaux adaptés, utilisez de l’eau tiède et un nettoyant doux.",
        "Rincez soigneusement. Séchez à plat, tête du pinceau dégagée ; ne faites pas tremper le manche ni la virole."
      ]
    ]
  },
  "it": {
    "ui": [
      "Aiuto con il mio\nnuovo prodotto",
      "Rahel ti accompagna. Scegli l’argomento per cui desideri consigli.",
      "Da dove vuoi iniziare?",
      "Ombretti & effetti",
      "Prodotti labbra",
      "Illuminante",
      "Cura dei pennelli",
      "Segui prima le indicazioni sul prodotto e sulla confezione. Interrompi l’uso in caso di irritazione.",
      "Chiedi a Rahel del mio prodotto",
      "Il pacco è arrivato,\nma…",
      "Emanuel ti aiuta. Che cosa è successo con la consegna?",
      "Manca un articolo",
      "Ho ricevuto l’articolo sbagliato",
      "Un articolo è danneggiato",
      "Nel prossimo passaggio puoi aggiungere numero d’ordine, articolo e foto. Non occorre inviare di nuovo foto già trasmesse.",
      "Sorprendimi,\nRahel!",
      "Scegli lo stile e un prezzo massimo. Rahel mostra fino a tre prodotti disponibili dalla sua piccola selezione.",
      "Che cosa ti ispira?",
      "Discreto – tocchi delicati",
      "Scintillante – luce & riflessi",
      "Audace – colori & contrasti",
      "Prezzo massimo per prodotto",
      "Il limite vale per prodotto; la spedizione può essere aggiuntiva. Scheda prodotto e checkout mostrano i prezzi attuali.",
      "Mostrami le tue idee",
      "La tua selezione: {n} prodotti adatti.",
      "Nessun prodotto della selezione di Rahel è disponibile con queste scelte. Cambia stile o budget, oppure usa il Color Finder.",
      "Inserisci un prezzo massimo valido superiore a 0.",
      "Vedi prodotto",
      "Altri colori nel Color Finder"
    ],
    "steps": [
      [
        "Inizia con poco prodotto. Picchietta shimmer o multichrome se la marca consiglia questa tecnica.",
        "Sfuma i bordi opachi con un pennello pulito e morbido, senza pressione. Vicino agli occhi usa solo prodotti indicati per quella zona."
      ],
      [
        "Applica uno strato sottile dal centro delle labbra verso i contorni.",
        "Aumenta gradualmente l’intensità. Usa gloss o olio labbra come topper solo secondo le indicazioni della marca."
      ],
      [
        "Preleva poco prodotto con un pennello pulito e crea un piccolo punto luce sugli zigomi.",
        "Controlla alla luce del giorno e sovrapponi strati sottili. Vicino agli occhi usalo solo se indicato per quella zona."
      ],
      [
        "Pulisci regolarmente secondo le indicazioni del produttore. Per i pennelli adatti, usa acqua tiepida e detergente delicato.",
        "Risciacqua bene. Lascia asciugare in piano con la testa libera; non immergere manico o ghiera."
      ]
    ]
  },
  "es": {
    "ui": [
      "Ayuda con mi\nnuevo producto",
      "Rahel te acompaña. Elige sobre qué quieres consejos.",
      "¿Por dónde quieres empezar?",
      "Sombras & efectos",
      "Productos de labios",
      "Iluminador",
      "Cuidado de pinceles",
      "Sigue las indicaciones del producto y del envase. Deja de usarlo si aparece irritación.",
      "Preguntar a Rahel por mi producto",
      "Mi paquete llegó,\npero…",
      "Emanuel te ayuda. ¿Qué ocurrió con tu entrega?",
      "Falta un artículo",
      "Recibí un artículo equivocado",
      "Un artículo está dañado",
      "Después puedes añadir número de pedido, artículo y fotos. No hace falta reenviar fotos que ya hayas enviado.",
      "¡Sorpréndeme,\nRahel!",
      "Elige tu estilo y un precio máximo. Rahel muestra hasta tres productos disponibles de su pequeña selección.",
      "¿Qué te apetece?",
      "Discreto – toques suaves",
      "Brillante – luz & reflejos",
      "Atrevido – color & contrastes",
      "Precio máximo por producto",
      "El límite es por producto; el envío puede tener coste adicional. La ficha y el checkout muestran los precios actuales.",
      "Muéstrame tus ideas",
      "Tu selección: {n} productos adecuados.",
      "No hay productos disponibles en la selección de Rahel para estas opciones. Cambia el estilo o el presupuesto, o usa el Color Finder.",
      "Introduce un precio máximo válido mayor que 0.",
      "Ver producto",
      "Más colores en el Color Finder"
    ],
    "steps": [
      [
        "Empieza con poco producto. Aplica shimmer o multicromo a toques si la marca recomienda esa técnica.",
        "Difumina los bordes mates con un pincel limpio y suave, sin presionar. Cerca de los ojos usa solo productos indicados para esa zona."
      ],
      [
        "Aplica una capa fina desde el centro de los labios hacia los bordes.",
        "Aumenta la intensidad poco a poco. Usa gloss o aceite como topper solo según las indicaciones de la marca."
      ],
      [
        "Recoge poco producto con un pincel limpio y añade un pequeño toque en los pómulos.",
        "Comprueba el efecto con luz natural y añade capas finas. Cerca de los ojos úsalo solo si está indicado para esa zona."
      ],
      [
        "Limpia los pinceles según las indicaciones del fabricante. Para los pinceles adecuados, usa agua tibia y un limpiador suave.",
        "Aclara bien. Deja secar en horizontal con la cabeza libre; no sumerjas el mango ni la virola."
      ]
    ]
  },
  "pl": {
    "ui": [
      "Pomoc z moim\nnowym produktem",
      "Rahel pomoże Ci zacząć. Wybierz temat wskazówek.",
      "Od czego chcesz zacząć?",
      "Cienie i efekty",
      "Produkty do ust",
      "Rozświetlacz",
      "Pielęgnacja pędzli",
      "Najważniejsze są instrukcje na produkcie i opakowaniu. Przerwij stosowanie w razie podrażnienia.",
      "Zapytaj Rahel o mój produkt",
      "Paczka dotarła,\nale…",
      "Emanuel pomoże. Co się stało z dostawą?",
      "Brakuje artykułu",
      "Otrzymałam niewłaściwy artykuł",
      "Artykuł jest uszkodzony",
      "Następnie dodaj numer zamówienia, artykuł i zdjęcia. Nie musisz ponownie wysyłać przekazanych już zdjęć.",
      "Zaskocz mnie,\nRahel!",
      "Wybierz styl i limit ceny. Rahel pokaże do trzech dostępnych produktów ze swojej małej selekcji.",
      "Na co masz ochotę?",
      "Subtelnie – delikatne akcenty",
      "Błyszcząco – światło i refleksy",
      "Odważnie – kolor i kontrasty",
      "Limit ceny za produkt",
      "Limit dotyczy jednego produktu; wysyłka może być dodatkowo płatna. Aktualne ceny znajdziesz na stronie produktu i przy płatności.",
      "Pokaż pomysły",
      "Twój wybór: {n} pasujących produktów.",
      "W selekcji Rahel nie ma teraz dostępnych produktów dla tych opcji. Zmień styl lub limit albo użyj Color Finder.",
      "Podaj prawidłowy limit ceny większy od 0.",
      "Zobacz produkt",
      "Więcej kolorów w Color Finder"
    ],
    "steps": [
      [
        "Zacznij od małej ilości. Delikatnie wklepuj shimmer lub multichrome, jeśli marka zaleca tę metodę.",
        "Rozetrzyj matowe krawędzie czystym, miękkim pędzlem bez nacisku. Przy oczach używaj wyłącznie produktów do tego przeznaczonych."
      ],
      [
        "Nałóż cienką warstwę od środka ust do konturu.",
        "Stopniowo zwiększaj intensywność. Błyszczyka lub olejku jako toppera używaj tylko zgodnie z instrukcją marki."
      ],
      [
        "Nabierz odrobinę czystym pędzlem i dodaj mały akcent na kości policzkowe.",
        "Sprawdź efekt w świetle dziennym i buduj cienkie warstwy. Przy oczach używaj tylko wtedy, gdy produkt jest do tego przeznaczony."
      ],
      [
        "Czyść pędzle zgodnie z zaleceniami producenta. Do odpowiednich pędzli użyj letniej wody i łagodnego środka.",
        "Dokładnie wypłucz. Susz płasko z wolną główką; nie mocz trzonka ani skuwki."
      ]
    ]
  },
  "sv": {
    "ui": [
      "Hjälp med min\nnya produkt",
      "Rahel hjälper dig att komma igång. Välj vad du vill ha tips om.",
      "Var vill du börja?",
      "Ögonskugga & effekter",
      "Läpprodukter",
      "Highlighter",
      "Penselvård",
      "Följ alltid produktens och förpackningens anvisningar. Sluta använda produkten vid irritation.",
      "Fråga Rahel om min produkt",
      "Paketet är här,\nmen…",
      "Emanuel hjälper dig. Vad hände med leveransen?",
      "En vara saknas",
      "Jag fick fel vara",
      "En vara är skadad",
      "Lägg sedan till ordernummer, berörd vara och bilder. Bilder som du redan har skickat behöver du inte skicka igen.",
      "Överraska mig,\nRahel!",
      "Välj din stil och ett pristak. Rahel visar upp till tre tillgängliga produkter ur sitt lilla urval.",
      "Vad känner du för?",
      "Diskret – mjuka accenter",
      "Glittrande – ljus & skiftningar",
      "Djärvt – färg & kontraster",
      "Pristak per produkt",
      "Gränsen gäller per produkt; frakt kan tillkomma. Produktsidan och kassan visar aktuella priser.",
      "Visa dina idéer",
      "Ditt urval: {n} matchande produkter.",
      "Inget i Rahels urval är tillgängligt för dessa val. Ändra stil eller pristak, eller använd Color Finder.",
      "Ange ett giltigt pristak över 0.",
      "Visa produkt",
      "Fler färger i Color Finder"
    ],
    "steps": [
      [
        "Börja med lite produkt. Klappa försiktigt på skimmer eller multichrome om märket rekommenderar det.",
        "Sudda matta kanter med en ren, mjuk pensel och lätt tryck. Använd bara produkter avsedda för ögonområdet runt ögonen."
      ],
      [
        "Börja med ett tunt lager från mitten av läpparna mot konturerna.",
        "Bygg intensiteten långsamt. Använd gloss eller läppolja som topper bara enligt märkets anvisningar."
      ],
      [
        "Ta lite produkt med en ren pensel och lägg en liten accent på kindbenen.",
        "Kontrollera i dagsljus och bygg i tunna lager. Använd runt ögonen bara om produkten är avsedd för det."
      ],
      [
        "Rengör regelbundet enligt tillverkarens anvisningar. Använd ljummet vatten och mild rengöring för penslar som tål det.",
        "Skölj noga. Torka plant med penselhuvudet fritt; blötlägg inte skaft eller metallhylsa."
      ]
    ]
  },
  "fi": {
    "ui": [
      "Apua uuden\n tuotteeni käyttöön",
      "Rahel auttaa alkuun. Valitse aihe, josta haluat vinkkejä.",
      "Mistä haluat aloittaa?",
      "Luomivärit ja efektit",
      "Huulituotteet",
      "Korostusväri",
      "Siveltimien hoito",
      "Noudata tuotteen ja pakkauksen ohjeita. Lopeta käyttö, jos iho ärtyy.",
      "Kysy Rahelilta tuotteestani",
      "Paketti saapui,\nmutta…",
      "Emanuel auttaa. Mitä toimitukselle tapahtui?",
      "Tuote puuttuu",
      "Sain väärän tuotteen",
      "Tuote on vaurioitunut",
      "Lisää seuraavaksi tilausnumero, tuote ja kuvat. Jo lähetettyjä kuvia ei tarvitse lähettää uudelleen.",
      "Yllätä minut,\nRahel!",
      "Valitse tyyli ja hintaraja. Rahel näyttää enintään kolme saatavilla olevaa tuotetta pienestä valikoimastaan.",
      "Mitä tekisi mieli?",
      "Hillitty – pehmeät korostukset",
      "Säihkyvä – valo ja värinvaihdot",
      "Rohkea – värit ja kontrastit",
      "Hintaraja tuotetta kohden",
      "Raja koskee yhtä tuotetta; toimituskuluja voi tulla lisäksi. Tuotesivu ja kassa näyttävät ajantasaiset hinnat.",
      "Näytä ideasi",
      "Valintasi: {n} sopivaa tuotetta.",
      "Rahelin valikoimassa ei ole nyt saatavilla tuotteita näillä valinnoilla. Vaihda tyyliä tai hintarajaa tai käytä Color Finderia.",
      "Anna kelvollinen hintaraja, joka on yli 0.",
      "Näytä tuote",
      "Lisää värejä Color Finderissa"
    ],
    "steps": [
      [
        "Aloita pienellä määrällä. Painele shimmeriä tai multichromea kevyesti, jos valmistaja suosittelee tätä tapaa.",
        "Häivytä mattarajat puhtaalla, pehmeällä siveltimellä kevyesti. Silmien lähellä käytä vain alueelle tarkoitettuja tuotteita."
      ],
      [
        "Levitä ensin ohut kerros huulten keskeltä reunoille.",
        "Lisää voimakkuutta vähitellen. Käytä kiiltoa tai huuliöljyä topperina vain valmistajan ohjeiden mukaan."
      ],
      [
        "Ota vähän tuotetta puhtaalla siveltimellä ja lisää pieni korostus poskipäille.",
        "Tarkista päivänvalossa ja lisää ohuita kerroksia. Käytä silmien lähellä vain, jos tuote on siihen tarkoitettu."
      ],
      [
        "Puhdista säännöllisesti valmistajan ohjeiden mukaan. Sopiville siveltimille voi käyttää haaleaa vettä ja mietoa puhdistusainetta.",
        "Huuhtele huolellisesti. Kuivata vaakatasossa sivellinpää vapaana; älä liota vartta tai metalliholkkia."
      ]
    ]
  },
  "nl": {
    "ui": [
      "Hulp met mijn\nnieuwe product",
      "Rahel helpt je op weg. Kies waarover je tips wilt.",
      "Waar wil je beginnen?",
      "Oogschaduw & effecten",
      "Lipproducten",
      "Highlighter",
      "Penseelverzorging",
      "Volg altijd de aanwijzingen op product en verpakking. Stop bij irritatie.",
      "Vraag Rahel over mijn product",
      "Mijn pakket is er,\nmaar…",
      "Emanuel helpt je. Wat is er met je levering gebeurd?",
      "Er ontbreekt een artikel",
      "Ik kreeg het verkeerde artikel",
      "Een artikel is beschadigd",
      "Voeg hierna je bestelnummer, artikel en foto’s toe. Foto’s die je al hebt gestuurd hoef je niet opnieuw te sturen.",
      "Verras me,\nRahel!",
      "Kies je stijl en een maximumprijs. Rahel toont tot drie beschikbare producten uit haar kleine selectie.",
      "Waar heb je zin in?",
      "Subtiel – zachte accenten",
      "Sprankelend – licht & kleurschakeringen",
      "Gedurfd – kleur & contrasten",
      "Maximumprijs per product",
      "De grens geldt per product; verzending kan extra kosten. Productpagina en checkout tonen de actuele prijzen.",
      "Laat je ideeën zien",
      "Jouw selectie: {n} passende producten.",
      "Er is nu niets uit Rahels selectie beschikbaar voor deze keuzes. Verander de stijl of prijsgrens, of gebruik de Color Finder.",
      "Vul een geldige maximumprijs boven 0 in.",
      "Bekijk product",
      "Meer kleuren in de Color Finder"
    ],
    "steps": [
      [
        "Begin met weinig product. Dep shimmer of multichrome zachtjes als het merk die methode aanbeveelt.",
        "Vervaag matte randen met een schoon, zacht penseel en weinig druk. Gebruik bij de ogen alleen producten voor dat gebied."
      ],
      [
        "Begin met een dunne laag van het midden van de lippen naar de randen.",
        "Bouw de intensiteit langzaam op. Gebruik gloss of lipolie als topper alleen volgens de aanwijzingen van het merk."
      ],
      [
        "Neem weinig product op met een schoon penseel en zet een klein accent op de jukbeenderen.",
        "Bekijk het effect bij daglicht en bouw dunne laagjes op. Gebruik bij de ogen alleen als het product daarvoor bedoeld is."
      ],
      [
        "Reinig regelmatig volgens de fabrikant. Gebruik voor geschikte penselen lauwwarm water en een milde reiniger.",
        "Spoel goed uit. Droog plat met de penseelkop vrij; laat steel of metalen huls niet weken."
      ]
    ]
  }
};
  const lang = (root.dataset.locale || 'en').split('-')[0];
  const {ui:t, steps} = copy[lang] || copy.en;
  const el = name => root.querySelector('[data-advisor-' + name + ']');
  const put = (name, value) => { el(name).textContent = value; };
  const title = index => t[index].replace(/\s*\n\s*/g, ' ');
  for (const [prefix,index] of [['care',0],['parcel',9],['surprise',15]]) {
    put(prefix+'-entry', t[index]); put(prefix+'-title', title(index));
  }
  for (const [name,index] of Object.entries({'care-intro':1,'care-label':2,'care-note':7,'care-question':8,'parcel-intro':10,'parcel-note':14,'surprise-intro':16,'surprise-style-label':17,'surprise-note':22,'surprise-find':23,'surprise-colors':28})) put(name,t[index]);
  const currency = root.dataset.currency || 'EUR';
  put('surprise-budget-label',t[21]+' ('+currency+')');
  const option = (value,text) => { const e=document.createElement('option');e.value=value;e.textContent=text;return e; };
  const topics=['eyes','lips','glow','brushes'];
  topics.forEach((value,i)=>el('care-topic').append(option(value,t[3+i])));
  const renderSteps = () => {
    el('care-steps').replaceChildren(...steps[topics.indexOf(el('care-topic').value)].map(text=>{const li=document.createElement('li');li.textContent=text;return li;}));
  };
  el('care-topic').addEventListener('change',renderSteps);renderSteps();
  el('care-question').addEventListener('click',()=>root.dispatchEvent(new CustomEvent('monolith:consultation',{detail:{topic:title(0)+' – '+el('care-topic').selectedOptions[0].textContent,source:el('care-question')}})));
  ['missing','wrong','damaged'].forEach((key,i)=>{
    const b=document.createElement('button');b.type='button';b.className='mono-advisors__gift-entry';b.textContent=t[11+i];b.dataset.advisorParcelKind=key;
    b.addEventListener('click',()=>root.dispatchEvent(new CustomEvent('monolith:navigate',{detail:{kind:'order',key}})));
    el('parcel-options').append(b);
  });
  ['soft','sparkle','bold'].forEach((value,i)=>el('surprise-style').append(option(value,t[18+i])));
  let products=[];
  try { const data=JSON.parse(el('surprise-products').textContent);if(Array.isArray(data)) products=data; } catch {}
  const safeUrl = value => {try{const u=new URL(value,location.origin);return u.origin===location.origin && /\/products\//.test(u.pathname)?u:null;}catch{return null;}};
  const pool = products.filter(p=>['soft','sparkle','bold'].includes(p.style) && Number.isSafeInteger(p.price) && p.price>=0 && typeof p.title==='string' && typeof p.money==='string' && safeUrl(p.url));
  const results=el('surprise-results'),status=el('surprise-status'),budget=el('surprise-budget');
  const surpriseNav=document.createElement('div');surpriseNav.className='mono-advisors__shop-nav';surpriseNav.hidden=true;
  const surprisePrev=document.createElement('button'),surpriseNext=document.createElement('button'),surprisePosition=document.createElement('span');
  surprisePrev.type=surpriseNext.type='button';surprisePrev.textContent='←';surpriseNext.textContent='→';
  const surpriseControls={de:['Vorherige Ideen','Nächste Ideen','von'],en:['Previous ideas','Next ideas','of'],fr:['Idées précédentes','Idées suivantes','sur'],it:['Idee precedenti','Idee successive','di'],es:['Ideas anteriores','Ideas siguientes','de'],pl:['Poprzednie pomysły','Następne pomysły','z'],sv:['Föregående idéer','Nästa idéer','av'],fi:['Edelliset ideat','Seuraavat ideat','/'],nl:['Vorige ideeën','Volgende ideeën','van']}[lang] || ['Previous ideas','Next ideas','of'];
  surprisePrev.setAttribute('aria-label',surpriseControls[0]);surpriseNext.setAttribute('aria-label',surpriseControls[1]);
  surpriseNav.append(surprisePrev,surprisePosition,surpriseNext);results.before(surpriseNav);
  let surpriseIndex=0;
  const showSurprise=()=>{const cards=[...results.children];surpriseNav.hidden=cards.length<=2;cards.forEach((card,index)=>{card.hidden=index<surpriseIndex||index>=surpriseIndex+2;});surprisePrev.disabled=surpriseIndex===0;surpriseNext.disabled=surpriseIndex+2>=cards.length;surprisePosition.textContent=`${surpriseIndex+1}–${Math.min(cards.length,surpriseIndex+2)} ${surpriseControls[2]} ${cards.length}`;};
  surprisePrev.addEventListener('click',()=>{surpriseIndex=Math.max(0,surpriseIndex-2);showSurprise();});
  surpriseNext.addEventListener('click',()=>{surpriseIndex+=2;showSurprise();});
  let lastIds='';
  const reset=()=>{results.replaceChildren();status.textContent='';surpriseNav.hidden=true;surpriseIndex=0;};
  budget.addEventListener('input',reset);el('surprise-style').addEventListener('change',reset);
  el('surprise-find').addEventListener('click',()=>{
    reset();
    const amount=budget.valueAsNumber;
    if(!budget.checkValidity() || !Number.isFinite(amount) || amount<=0){status.textContent=t[26];budget.reportValidity();budget.focus();return;}
    const candidates=pool.filter(p=>p.style===el('surprise-style').value && p.price<=Math.round(amount*100));
    // Shuffle without changing the catalog; never broaden the selected style or budget.
    for(let i=candidates.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[candidates[i],candidates[j]]=[candidates[j],candidates[i]];}
    if(candidates.length>3 && candidates.slice(0,3).map(p=>p.id).sort().join()===lastIds)candidates.push(candidates.shift());
    const selected=candidates.slice(0,3);lastIds=selected.map(p=>p.id).sort().join();
    status.textContent=selected.length?t[24].replace('{n}',String(selected.length)):t[25];
    for(const p of selected){
      const article=document.createElement('article');article.className='mono-advisors__care-card';
      const link=document.createElement('a');const u=safeUrl(p.url);
      const preview=new URLSearchParams(location.search).get('preview_theme_id');if(preview)u.searchParams.set('preview_theme_id',preview);
      link.href=u.href;
      link.target='_blank';link.rel='noopener noreferrer';
      if(p.image){try{const imgUrl=new URL(p.image,location.origin);if(imgUrl.protocol==='https:'){const image=document.createElement('img');image.src=imgUrl.href;image.alt='';image.loading='lazy';image.width=100;image.height=100;link.append(image);}}catch{}}
      const name=document.createElement('strong');name.textContent=p.title;
      const price=document.createElement('span');price.textContent=p.money;
      const view=document.createElement('span');view.className='mono-advisors__care-link';view.textContent=t[27];
      link.append(name,price,view);article.append(link);results.append(article);
    }
    if(selected.length)showSurprise();
  });
})();

